import { render, staticRenderFns } from "./driverInfo.vue?vue&type=template&id=fdee10ee&scoped=true&"
import script from "./driverInfo.vue?vue&type=script&lang=js&"
export * from "./driverInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdee10ee",
  null
  
)

export default component.exports